export const CLEAR_DATA = 'CLEAR_DATA';
export const CLEAR_COMPLETE = 'CLEAR_COMPLETE';
